//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "CardServe",
  components: {},
  props: ["w", "h"],
  data: function data() {
    return {
      loading: false,
      baseUrl: process.env.BASE_URL,
      list: [],
      pageNum: 1,
      col: 8
    };
  },
  computed: {
    pageSize: function pageSize() {
      return this.w * 3 * (this.h * 2);
    }
  },
  created: function created() {
    this.fetchList();
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    fetchList: function fetchList() {
      var _this = this;

      this.loading = true;
      this.$http.post("/hallServe/servePermitList", this.$qs.stringify({
        pageNum: 1,
        pageSize: this.pageSize,
        recommend: ""
      })).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode == 0) {
          _this.list = data.resData.list;

          _this.$nextTick(function () {
            _this.computeCol();
          });
        }

        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    // 访问统计计数器
    serverInsert: function serverInsert(item) {
      switch (item.serveType * 1) {
        case 0:
          this.$router.push({
            path: "/serveSearch/".concat(item.id, "/").concat(item.interfaceUrl)
          });
          break;

        case 1:
          this.$router.push({
            path: "/serveApproval/".concat(item.id)
          });
          break;

        case 2:
          this.$router.push({
            path: "/serveCustomized/".concat(item.id, "/").concat(item.interfaceUrl)
          });
          break;

        case 9:
          this.$http.post("/statistical/serverInsert", this.$qs.stringify({
            serviceId: item.id,
            appType: 9
          })).then(function () {}).catch(function () {});
          this.url = this.data.linkUrl;
          this.$refs.url.click();
          break;

        default:
          break;
      }
    },
    // 每次获取计算列个数
    computeCol: function computeCol() {
      switch (this.w) {
        case 1:
          this.col = 8;
          break;

        case 2:
          this.col = 4;
          break;

        case 3:
          this.col = 3;
          break;

        default:
          break;
      }
    },
    resizedEvent: function resizedEvent() {
      this.fetchList();
    }
  },
  watch: {},
  filters: {}
};